import { Autocomplete, TextField } from '@mui/material';
import React from 'react';
import { Control, Controller, UseFormGetValues } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { AllEnums, EnumListKey } from '~/data/enums';
import { useFilterActiveEnumsByFormSelections } from '~/features/ScheduledEmploymentChanges/ScheduleChanges/data/useFilterActiveEnumsByFormSelections';
import { Form } from '~/features/ScheduledEmploymentChanges/ScheduleChanges/useScheduleChanges';

type Props = {
  control: Control<Form>;
  getValues: UseFormGetValues<Form>;
  allEnums: AllEnums;
  index: number;
};

export const InternalPositionComponent = (props: Props) => {
  const { control, getValues, allEnums, index } = props;

  const { t } = useTranslation();
  const requiredText = t('fieldIsRequired');

  const {
    filterActiveEnumsByFormSelections,
    currentFieldValue: { fEmpLegalEntityValue },
  } = useFilterActiveEnumsByFormSelections({
    control,
    index,
    getValues,
  });

  const filteredOptions = filterActiveEnumsByFormSelections(
    allEnums[EnumListKey.EMPLOYEE_POSITION],
  );

  return (
    <Controller
      control={control}
      name={`schedule.${index}.empPosition.fInternalPositionPosition`}
      rules={{ required: requiredText }}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <Autocomplete
          placeholder={t('laSelectFirstLegEnt')}
          disabled={fEmpLegalEntityValue === ''}
          options={filteredOptions}
          getOptionLabel={(c) => c?.name || ''}
          onChange={(e, value) => {
            onChange(value?.code || '');
          }}
          value={filteredOptions.find((ep) => ep?.code === value) || null}
          size={'small'}
          data-testid="internal-position-autocomplete"
          renderInput={(params) => (
            <TextField
              {...params}
              label={t('laPosition')}
              required={true}
              error={!!error}
              helperText={error?.message}
              data-testid="internal-position-input"
              InputLabelProps={{ shrink: true }}
            />
          )}
          fullWidth={true}
        />
      )}
    />
  );
};
